<template>
  <v-container>
    <v-app-bar app color="footer" dark elevation="0">
      <v-app-bar-nav-icon
        v-if="!sidebarMenu"
        color="basic"
        @click.stop="sidebarMenu = !sidebarMenu"
      ></v-app-bar-nav-icon>
      <v-spacer></v-spacer>
      <v-btn @click="changeTheme" icon
        ><v-icon :color="$vuetify.theme.dark ? 'white' : 'black'"
          >mdi-invert-colors</v-icon
        ></v-btn
      >
      <v-btn outlined @click="logout" color="basic" class="mr-2">Logout</v-btn>
    </v-app-bar>

    <v-navigation-drawer
      color="app"
      v-if="!serverDown"
      app
      floating
      v-model="sidebarMenu"
      :permanent="sidebarMenu"
      :mini-variant.sync="mini"
    >
      <v-list dense color="footer">
        <v-list-item dense>
          <v-list-item-action>
            <v-icon color="basic" @click.stop="sidebarMenu = !sidebarMenu"
              >mdi-chevron-left</v-icon
            >
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>
              <!-- <h3 class="font-weight-thin" style="color: white"></h3> -->
              <a @click="goHome">
                <Logo
                  :fillColor="$vuetify.theme.dark ? 'white' : 'black'"
                ></Logo>
              </a>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <v-list-item class="px-2" @click="toggleMini = !toggleMini" dense>
        <v-list-item-avatar>
          <v-icon color="accent">mdi-account-circle</v-icon>
        </v-list-item-avatar>
        <v-list-item-content class="text-truncate">
          <span v-if="user == ''" class="grey--text">..................</span>
          <span v-else> {{ user.name }} {{ user.surname }} </span>
        </v-list-item-content>
        <v-btn icon small>
          <v-icon>mdi-chevron-left</v-icon>
        </v-btn>
      </v-list-item>
      <v-divider></v-divider>
      <v-list dense>
        <v-list-item
          dense
          v-for="item in filteredItems"
          :key="item.title"
          link
          :to="item.href"
        >
          <v-list-item-icon>
            <v-icon color="basic_secondary">{{ item.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title class="basic--text">{{
              item.title
            }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
  </v-container>
</template>

<script>
import axios from "axios";
import Logo from "../atoms/Logo.vue";

export default {
  name: "Nav",
  components: {
    Logo,
  },
  data: () => ({
    sidebarMenu: true,
    toggleMini: false,
    user: "",
    items: [],
    permissions: [],
    filteredItems: [],
    serverDown: false,
  }),
  computed: {
    mini: {
      get() {
        return this.$vuetify.breakpoint.smAndDown || this.toggleMini;
      },
      set() {
        //this setter just fixes the warning :))
      },
    },
  },
  mounted() {
    if (localStorage.getItem("token")) {
      axios
        .get("api/user/" + localStorage.getItem("user-id") + "?")
        .then((response) => {
          this.user = response.data;
          this.formatNav();
        })
        .catch((e) => {
          console.log("ERROR IN NAVBAR", e.response.status);
          switch (e.response.status) {
            case 400:
              console.log("bad request");
              break;
            case 401:
              //clear local storage, push to login
              localStorage.clear();
              this.$router.push("login");
              break;
            case 406:
              //clear local storage, push to login
              localStorage.clear();
              this.$router.push("login");
              break;
            case 403:
              console.log("forbidden");
              break;
            case 404:
              console.log("forbidden");
              break;
            case 500:
              //stop show navigation drawer
              localStorage.clear();
              this.$router.push("login");
          }
        });
    } else {
      this.$router.push("login");
    }
  },
  methods: {
    goHome() {
      if (this.$router.currentRoute.name != "home") {
        this.$router.push("/");
      }
    },
    logout() {
      localStorage.clear();
      this.$root.$emit("reload", "reload");
      this.$router.push("/login");
    },
    formatNav() {
      // this.filteredItems.push({
      //   title: "Home",
      //   href: "/",
      //   icon: "mdi-home",
      //   access: false,
      // });
      this.items = [
        {
          title: "Item registration",
          href: "/registration",
          icon: "mdi-home-plus",
          access: false,
          perm: "Can register products",
          legacyOnly: true,
        },
        {
          title: "Write descriptions",
          href: "/descriptions",
          icon: "mdi-playlist-plus",
          access: false,
          perm: "Can write descriptions",
        },
        {
          title: "Listing supervision",
          href: "/listingsupervision",
          icon: "mdi-cryengine",
          access: false,
          perm: "Can view listings",
        },
        {
          title: "Wholesales products",
          href: "/wholesales-products",
          icon: "mdi-cryengine",
          access: false,
          perm: "Can view listings",
          legacyOnly: true,
        },
        {
          title: "Statistics",
          href: "/statistics",
          icon: "mdi-star-check-outline",
          access: false,
          perm: "Can view KPI dashboard",
        },
        {
          title: "Supply",
          href: "/supply",
          icon: "mdi-archive-arrow-down",
          access: false,
          perm: "Can manage supply",
          legacyOnly: true,
        },
        {
          title: "Settings",
          href: "/settings",
          icon: "mdi-cog-outline",
          access: false,
          perm: "Can manage configuration",
        },
        {
          title: "WholeSales Settings",
          href: "/wh-settings",
          icon: "mdi-cog-outline",
          access: false,
          perm: "Can manage configuration",
          legacyOnly: true,
        },
        {
          title: "Users configuration",
          href: "/users",
          icon: "mdi-account-supervisor",
          access: false,
          perm: "Can manage users",
        },
        {
          title: "Flash Sales",
          href: "/flashsales",
          icon: "mdi-flash-circle",
          access: false,
          perm: "Flash selling",
          legacyOnly: true,
        },
        {
          title: "Platform upload history",
          href: "/platformUploadHistory",
          icon: "mdi-history",
          access: false,
          perm: "Can view listings",
        },
      ];

      this.permissions = localStorage.getItem("permissions").split(",");
      // Legacy (brandclub.site SSO) sessions keep the full old menu. Only sessions
      // that signed in DIRECTLY on productsdb.com (entrySource === "direct") get the
      // new, enrichment-only menu. Anything not explicitly "direct" is treated as legacy.
      var legacyMode = localStorage.getItem("entrySource") !== "direct";
      for (var item in this.items) {
        if (this.items[item].legacyOnly && !legacyMode) {
          continue;
        }
        if (this.permissions.includes(this.items[item].perm)) {
          this.items[item].access = true;
          this.filteredItems.push(this.items[item]);
        }
      }
    },
    changeTheme() {
      this.$vuetify.theme.dark = !this.$vuetify.theme.dark;
      if (this.$vuetify.theme.dark) {
        localStorage.setItem("dark", 0);
      } else {
        localStorage.removeItem("dark");
      }
    },
  },
};
</script>
